import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ApprovedHoursStatus = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center' }, "data-test": 'approved-hours-status' },
        React.createElement(CheckCircleIcon, { sx: { color: themeColors.accent.green.bold }, fontSize: 'small' }),
        React.createElement(Typography, { variant: 'subtitle2', color: themeColors.accent.green.bold }, t('timeTracking.approved'))));
};
